import { Component, Input, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { TooltipOptions } from 'ng2-tooltip-directive';

type TPlacement = 'top' | 'bottom' | 'left' | 'right';
type TTrigger = 'hover' | 'click';

@Component({
  selector: 'app-tooltip-label',
  templateUrl: './tooltip-label.component.html',
  styleUrls: ['./tooltip-label.component.scss'],
})

/**
 * Muestra tooltip
 * Documentación oficial del complemento usado: http://ivylab.space/tooltip
 */
export class TooltipLabelComponent implements OnInit {
  /** Desahabilita / habilita componente */
  @Input() disabled: boolean;

  /** Mensaje a mostrar */
  @Input() message: string;

  /** Lugar donde será mostrado */
  @Input() placement?: TPlacement;

  /** Si el posicionamiento es automático o no (puede salirse de los bordes) */
  @Input() autoPlacement: boolean;

  /** Ancho */
  @Input() width: string;

  /** Ancho máximo */
  @Input() maxWidth: string;

  /** Icono (debe ser de Material Design): https://material.io/resources/icons/ */
  @Input() icon: string;

  /** Evento que gatilla la aparición del tooltip */
  @Input() trigger: TTrigger;

  /** Setea estética en CSS */
  @Input() tooltipClass: string;

  /** Milisegundos que transcurren para ser mostrado */
  @Input() showDelay: number;

  /** Milisegundos que transcurren para ser ocultado */
  @Input() hideDelay: number;

  /** Desplazamiento (separación) en pixeles desde el borde del elemento */
  @Input() offset: number;

  /** Comodín para ingresar cualquier opción aquí */
  @Input() options: TooltipOptions;

  constructor(public platform: Platform) {
    this.disabled = !true;
    this.message = '';
    this.placement = 'top';
    this.autoPlacement = true;
    this.width = '150px';
    this.maxWidth = '660px';
    this.icon = 'help';
    this.trigger = 'hover'; // Por defecto para escritorio
    this.tooltipClass = 'custom-tooltip';
    this.showDelay = 0; // 300 (en milisegundos)
    this.hideDelay = 0;
    this.offset = 10;
    this.options = { placement: 'top' };
  }

  ngOnInit() {
    if (this.platform.is('mobile')) {
      this.trigger = 'click'; // 'hover' on existe en mobile, por lo que se usa acá con 'click'
    }
  }
}
